// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewMessageButton__button-bc4d8c {
  position: absolute;
  inset-inline-end: 16px;
  bottom: 16px;
  box-shadow: var(--drop-shadow-2);
}

.NewMessageButton__icon-be2c3b {
  pointer-events: none;
}

.NewMessageButton__menu-bea256 {
  min-width: 216px;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/NewMessageButton/NewMessageButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,gCAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".button {\n  position: absolute;\n  inset-inline-end: 16px;\n  bottom: 16px;\n  box-shadow: var(--drop-shadow-2);\n}\n\n.icon {\n  pointer-events: none;\n}\n\n.menu {\n  min-width: 216px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `NewMessageButton__button-bc4d8c`,
	"icon": `NewMessageButton__icon-be2c3b`,
	"menu": `NewMessageButton__menu-bea256`
};
module.exports = ___CSS_LOADER_EXPORT___;
